import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { CircleProgress } from '@/components/CircleProgress';
import { ReviewCards } from '@/components/ReviewCards';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { OnboardingFooter } from '../../../../components/Footer';
import { OnboardingPage } from '../../../../components/Page';
import { OnboardingTitle } from '../../../../components/Title';
import { useOnboarding } from '../../../../context';
import { useQueryPersonalizedAis } from '../../../../hooks/useQueryPersonalizedAis';
import { LayoutDataType } from '../../types';

import './PersonalizingFeed.scss';

export const OnboardingReplikaPersonalizingFeed: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Personalizing Feed',
      });
    }
  }, []);

  const [hideNextButton, setHideNextButton] = React.useState(true);

  const onSuccess = () => {
    setHideNextButton(false);
  };

  const [enableQuery, setEnableQuery] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setEnableQuery(true);
    }, 2000);
  });

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  useQueryPersonalizedAis({
    enabled: enableQuery,
    form,
    onSuccess: (data) => {
      form.setValue('characters', data.twins);

      data.twins.forEach((twin) => {
        preloadImage(twin.profile_picture_url);
      });
    },
  });

  return (
    <OnboardingPage className="onboarding-presonalizing-feed">
      <IonContent>
        <CircleProgress
          className="progress-circle"
          size={220}
          strokeWidth={10}
          onFinish={onSuccess}
          key="personalizing-feed-progress"
        />
        <OnboardingTitle>
          Preparing the stage for your AI adventure. Almost there!
        </OnboardingTitle>

        <section className="user-reviews">
          <ReviewCards />
        </section>
      </IonContent>

      <OnboardingFooter hidden={hideNextButton} onContinue={wizard.nextStep} />
    </OnboardingPage>
  );
};
